import { createSelector } from 'reselect';
import { professionGiaWorldSkillsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const professionGiaWorldSkillsYearsSelector = createSelector(
  [professionGiaWorldSkillsSelector],
  (professionGiaWorldSkills) =>
    extractDatesFromNestedItems(
      [professionGiaWorldSkills.content],
      [
        {
          type: 'date',
          field: 'resultDate',
        },
      ],
    ),
);
